import { useState } from "react";
import { Input, Button } from "@dawa/ui";
import { supabase } from "../../lib/supabase";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Confirm() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [email, setEmail] = useState(params.get("email") ?? "");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="mx-auto mt-16 max-w-md space-y-4 p-6">
      <h1 className="text-xl font-bold">Confirmer votre email</h1>
      <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <Input
        placeholder="Code de confirmation"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />
      {error && <p className="text-sm text-danger">{error}</p>}
      {message && <p className="text-sm text-success">{message}</p>}
      <Button
        className="w-full"
        onClick={async () => {
          setError(null);
          const { error } = await supabase.auth.verifyOtp({
            email,
            token: code,
            type: "signup",
          });
          if (error) setError(error.message);
          else nav("/dashboard");
        }}
      >
        Valider
      </Button>
      <Button
        className="w-full"
        type="button"
        onClick={async () => {
          setError(null);
          const { error } = await supabase.auth.resend({
            type: "signup",
            email,
          });
          if (error) setError(error.message);
          else setMessage("Email envoyé");
        }}
      >
        Renvoyer le code
      </Button>
    </div>
  );
}
